import React from "react";
import QuotationForm from "./QuotationForm";

const QuotationMain = () => {
  return (
    <>
      <div
        id="react-contact"
        className="react-contact-page pt---100 form-container"
      >
        <div className="">
          <div className="row d-flex justify-content-center pb---96">
            <div className="">
              <QuotationForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuotationMain;
